import { ShieldCheck, Truck, ShieldPlus, Headset } from "lucide-react"
import { useTranslation } from "react-i18next"
import "./BenefitsSection.css"

const benefits = [
  {
    icon: ShieldCheck,
    title: "Safety & top quality",
    highlighted: false,
  },
  {
    icon: Truck,
    title: "On time delivery",
    description:
      "Streamlined logistics and stocked inventory ensure your safety equipment arrives exactly when your project needs it.",
    highlighted: true,
  },
  {
    icon: ShieldPlus,
    title: "Insurance coverage",
    highlighted: false,
  },
  {
    icon: Headset,
    title: "24/7 customer support",
    highlighted: false,
  },
]

export function BenefitsSection() {
  const { t } = useTranslation()
  return (
    <section id="benefits" className="benefits">
      <div className="container">
        <div className="benefits__header">
          <span className="benefits__badge">{t("Key Benefits")}</span>
          <h2 className="benefits__title">
            {t("Benefits of our road safety solutions")}
          </h2>
        </div>

        <div className="benefits__grid">
          {benefits.map((item) => {
            const Icon = item.icon
            return (
              <div
                key={item.title}
                className={`benefits__item ${
                  item.highlighted ? "benefits__item--active" : ""
                }`}
              >
                <span className="benefits__icon">
                  <Icon size={22} />
                </span>
                <h3 className="benefits__item-title">{t(item.title)}</h3>
                {item.description && (
                  <p className="benefits__item-text">{t(item.description)}</p>
                )}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
